﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadDrawingDimensionField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadDrawingDimensionField, eOutputFieldType.cadDrawingDimension)
export class CadDrawingDimensionField extends OutputField implements ICadDrawingDimensionField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public visible: boolean;
    public x: number;
    public y: number;
}
